import { Button, styled } from '@mui/material'
import { Flex, FlexBetween, FlexColumn, FlexStart, themeValue } from 'styles'
import { ReactComponent as SvgClose } from './close.svg'
import { ReactComponent as SvgAnchor } from './anchor.svg'

export const StyledSvgAnchor = styled(SvgAnchor)<{ light?: number }>`
  position: absolute;
  z-index: 120;
  cursor: pointer;
  color: ${({ light }) =>
    light === 1 ? 'rgba(168, 255, 0, 1)' : 'rgba(168, 255, 0, 0.5)'};
  &:hover {
    color: rgba(168, 255, 0, 1);
  }
`

export const Mask = styled('div')<{ height?: number }>`
  z-index: 120;
  position: absolute;
  width: 100%;
  inset: 0;
  top: 0px;
  height: 100%;
  overflow: hidden !important;
  height: ${({ height }) => (height ? height + 'px' : '100%')};
  background-color: ${() =>
    themeValue('rgba(0, 0, 0, 0.7)', 'rgba(5, 7, 20, 0.6)')};
  mix-blend-mode: hard-light;
`

export const HelpMask = styled('div')`
  border-radius: 4px;
  position: absolute;
  background-color: gray;
  opacity: 1;
  pointer-events: auto;
  top: 182px;
  transition: opacity 0.2s ease 0s;
  width: 115px;
}
`
export const Arrow = styled('div')`
  position: absolute;

  &.top {
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid;
    border-bottom-color: ${() =>
      themeValue('rgba(75, 82, 90, 1)', 'rgba(227, 229, 235, 1)')};
    position: absolute;
    z-index: 888;
    left: 50%;
    transform: translate(-50%, 0);
    top: -10px;

    &::after {
      content: '';
      width: 0;
      height: 0;
      border-color: transparent;
      border-bottom-color: ${() =>
        themeValue('rgba(30, 35, 41,1)', 'rgba(255, 255, 255, 1)')};
      border-style: dashed dashed solid dashed;
      position: absolute;
      top: -8px;
      left: -10px;
      font-size: 0;
      overflow: hidden;
      display: block;
      border-width: 10px;
    }
  }
  &.right {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid;
    border-left-color: ${() =>
      themeValue('rgba(75, 82, 90, 1)', 'rgba(227, 229, 235, 1)')};

    position: absolute;
    z-index: 888;
    right: -10px;
    top: 10px;

    &::after {
      content: '';
      width: 0;
      height: 0;
      border-color: transparent;
      border-left-color: ${() =>
        themeValue('rgba(30, 35, 41,1)', 'rgba(255, 255, 255, 1)')};
      border-style: dashed dashed dashed solid;
      position: absolute;
      top: -10px;
      right: -9px;
      font-size: 0;
      overflow: hidden;
      display: block;
      border-width: 10px;
    }
  }
  &.left {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid;
    border-right-color: ${() =>
      themeValue('rgba(75, 82, 90, 1)', 'rgba(227, 229, 235, 1)')};
    position: absolute;
    z-index: 888;
    left: -10px;
    top: 10px;

    &::after {
      content: '';
      width: 0;
      height: 0;
      border-color: transparent;
      border-right-color: ${() =>
        themeValue('rgba(30, 35, 41,1)', 'rgba(255, 255, 255, 1)')};
      border-style: dashed solid dashed dashed;
      position: absolute;
      top: -10px;
      left: -9px;
      font-size: 0;
      overflow: hidden;
      display: block;
      border-width: 10px;
    }
  }
`

export const Popover = styled('div')`
  position: absolute;
  z-index: 120;
`

export const StartTuorialBtn = styled(Button)`
  color: ${({ theme }) => theme.palette.primary.main};
  background-color: ${() =>
    themeValue('rgba(255, 255, 255, 0.1)', ' rgba(160, 160, 160, 0.10)')};
  border-radius: 2px;
  font-size: 14px;
  &:hover {
    background-color: ${() =>
      themeValue('rgba(255, 255, 255, 0.1)', ' rgba(160, 160, 160, 0.10)')};
    opacity: 0.9;
  }
  margin-left: 5px;
`

export const NoThanksButton = styled(Button)`
  color: ${() =>
    themeValue('rgba(164, 164, 164, 1)', 'rgba(145, 151, 176, 1)')};
  font-weight: normal;
  font-size: 14px;
  &:hover {
    background-color: transparent;
    opacity: 0.9;
  }
`

export const TuorialBox = styled(FlexColumn)`
  padding: 16px;
  border: 1px solid;
  border-color: ${() =>
    themeValue('rgba(75, 82, 90, 1)', 'rgba(227, 229, 235, 1)')};
  border-radius: 4px;
  background-color: ${() =>
    themeValue('rgba(30, 35, 41,1)', 'rgba(255, 255, 255, 1)')};
  width: 340px;
`

export const TuorialBoxTitle = styled('span')`
  color: ${() => themeValue('rgba(230, 230, 230,1)', 'rgba(51, 55, 67, 1)')};
  font-size: 14px;
  line-height: 20px;
`

export const TuorialBoxHelpText = styled('span')`
  font-size: 12px;
  padding: 6px;
  margin-top: 18px;
  color: ${() => themeValue('#d5d5d5', 'rgba(90, 102, 137, 1)')};
  text-align: center;
  border: 1px dashed;
  border-color: ${() =>
    themeValue('rgba(48, 48, 48, 1)', 'rgba(227, 229, 235, 1)')};
`

export const TuorialBoxFooter = styled(FlexBetween)`
  margin-top: 24px;
  align-items: center;
  font-size: 14px;
  text-align: center;
  button {
    flex: 1;
  }
`

export const StepFooter = styled(FlexBetween)`
  margin-top: 24px;
  button {
    flex: 1;
  }
`

export const StepBackButton = styled(Button)`
  margin-left: 5px;
  border-radius: 2px;
  height: 34px;
  background-color: ${() =>
    themeValue('rgba(255, 255, 255, 0.05)', 'rgba(128, 128, 128, 0.05)')};
  color: ${() =>
    themeValue('rgba(164, 164, 164, 0.2)', 'rgba(86, 86, 86, 0.28)')};

  display: flex;
  align-items: center;
  &:hover {
    background-color: ${() =>
      themeValue('rgba(255, 255, 255, 0.05)', 'rgba(128, 128, 128, 0.05)')};
    color: ${() =>
      themeValue('rgba(164, 164, 164, 0.2)', 'rgba(86, 86, 86, 0.28)')};
  }

  svg {
    margin-right: 5px;
    transform: rotate(180deg);
  }

  &.active {
    background-color: ${() =>
      themeValue('rgba(255, 255, 255, 0.1)', 'rgba(86, 86, 86, 0.10)')};
    color: ${() =>
      themeValue('rgba(255, 255, 255, 1)', 'rgba(90, 102, 137, 1)')};
    &:hover {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`

export const StepNextButton = styled(Button)`
  margin-left: 5px;
  border-radius: 2px;
  height: 34px;
  background-color: ${() =>
    themeValue('rgba(255, 255, 255, 0.05)', 'rgba(128, 128, 128, 0.05)')};
  color: ${() =>
    themeValue('rgba(164, 164, 164, 0.2)', 'rgba(86, 86, 86, 0.28)')};
  display: flex;
  align-items: center;

  svg {
    margin-left: 5px;
  }

  &.active {
    background-color: ${() =>
      themeValue('rgba(255, 255, 255, 0.1)', 'rgba(86, 86, 86, 0.10)')};
    color: ${() =>
      themeValue('rgba(255, 255, 255, 1)', 'rgba(90, 102, 137, 1)')};
    &:hover {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  &.finished {
    color: ${({ theme }) => theme.palette.primary.main};
    background-color: ${() =>
      themeValue('rgba(255, 255, 255, 0.1)', 'rgba(86, 86, 86, 0.10)')};
    &:hover {
      opacity: 0.9;
    }
  }
`

export const Close = styled(SvgClose)`
  color: ${(props) => props.theme.color?.text60};
  cursor: pointer;
`

export const StepTitle = styled('span')`
  color: ${() => themeValue('rgba(255, 255, 255, 1)', 'rgba(51, 55, 67, 1)')};
  font-size: 16px;
  font-weight: 600;
`

export const StepIntro = styled('span')`
  font-size: 14px;
  color: ${(props) => props.theme.color?.text60};
  margin-left: 5px;
`

export const StepLink = styled('a')`
  display: inline-block;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  margin-top: 18px;
  text-decoration: underline;
  cursor: pointer;
`

export const StepTwoBox = styled(TuorialBox)``

export const StepDesc = styled('span')`
  font-size: 14px;
  color: ${(props) => props.theme.color?.text80};
  margin-top: 18px;
  line-height: 20px;
`

export const StepColumnList = styled(FlexColumn)`
  margin-top: 18px;
`

export const ColorBid = styled('span')`
  color: rgba(14, 203, 129, 1);
`
export const ColorAsk = styled('span')`
  color: rgba(245, 69, 93, 1);
`
export const ColorNormal = styled('span')`
  color: rgba(213, 213, 213, 1);
`
export const ColorMain = styled('span')`
  color: ${({ theme }) => theme.palette.primary.main};
`

export const StepColumnItem = styled(FlexStart)`
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
`

export const StepColumnWrapItem = styled('div')`
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
  word-break: break-all;
`
